<template>

  <div class="flex flex-col">
    {{ $e("Palette infrarouge") }} :
    <div class="flex flex-wrap">
      <template v-for="(name, index) in palette" :key="index">
        <button @click="setPalette(index)" class="btn">{{ name.replace('_', ' ') }}</button>
      </template>
    </div>
  </div>

</template>

<script>
import API from "@/utils/API.js";
import { toast } from "vue3-toastify";

export default {
  name: "IrPalette",
  props: {
    config: Object,
  },
  setup() {
    return {
      palette: {
        "0": "WHITE_HOT",
        "1": "BLACK_HOT",
        "2": "RED_HOT",
        "3": "GREEN_HOT",
        "5": "RAINBOW",
        "6": "IRONBOW1",
        "8": "ICE_FIRE",
        "11": "COLOR1",
        "12": "COLOR2",
        "13": "RAIN"
      }
    };
  },
  methods: {
    async setPalette(palette) {
      let data = await API.put("property", {
        DockId: this.config.deviceFamilly.this_dev_id,
        PropNameValue: `"${this.config.camera.payload_index}":{"thermal_current_palette_style":${palette}}`
      });

      toast.info(
        this.$e("Palette infrarouge modifiée"),
        this.$root.toastConfig
      );
    }
  },
};
</script>
